<template>
  <div class="modal-card">
    <div class="row-width-actions-bar">
      <div class="columns is-gapless is-vcentered is-border-bottom">
        <div class="column is-padding-left">
          <div class="has-text-dark is-size-6 is-uppercase">
            <span class="has-text-weight-medium">Documents Espace Acquereur</span>
          </div>
        </div>
        <div class="column is-narrow is-border-left">
          <a
            class="page-header-btn is-small is-square"
            @click="close">
            <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
          </a>
        </div>
      </div>
    </div>
    <section class="modal-card-body is-paddingless">
      <div
        class="columns is-gapless is-clipped is-max-height-full"
        style="height: 500px; max-height: 80vh;">
        <div
          class="column is-12 is-overflow-auto"
          style="height: auto;">
          <template v-for="(item, keyDocument, i) in source">
            <div
              class="row-width-actions-bar columns is-marginless is-gapless is-vcentered is-border-bottom"
              :key="'parent-'+i">
              <div class="column is-padding-left">
                <span class="has-text-dark is-size-6">{{ item.label }}</span>
              </div>
              <div class="column is-narrow is-border-left">
                <button
                  :disabled="item.documents < 1"
                  class="page-header-btn is-small is-square"
                  @click="toggleTable(keyDocument)">
                  <span class="icon is-size-4 has-text-dark">
                    <i
                      class="fal"
                      :class="open[keyDocument] ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  </span>
                </button>
              </div>
            </div>
            <div
              class="vadRowSimple is-hoverable"
              v-show="open[keyDocument]"
              v-for="document in item.documents"
              :key="'doc-' + Math.floor(Math.random(2) * 10000) + document.fus_id">
              <span class="is-size-6">{{ document.filename }}</span>
              <a
                class="vadRowSimple-actions"
                target="_blank"
                :href="document.path"
                :download="document.filename">
                <span class="is-size-7 is-uppercase">Télécharger</span>
              </a>
            </div>
          </template>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'EventDocumentModal',
  props: {
    active: {
      type: Boolean,
      required: true
    },
    source: {
      type: Object,
      required: true
    },
    params: {
      type: Object
    }
  },
  data () {
    return {
      open: {}
    }
  },
  watch: {
    source () {
      this.open = Object.keys(this.source).map(x => {
        return { [x]: false }
      })
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    toggleTable (v) {
      this.$set(this.open, [v], !this.open[v])
    },
    download (document) {
      let link = document.createElement('a')
      link.href = document.path
      link.target = '_blank'
      link.click()
    }
  }
}
</script>
